/* eslint-disable camelcase */
import * as React from "react"
import * as yup from "yup"
import { Appearance, ViewStyle } from "react-native"
import { Farm, Pond } from "../../../database"
import { DateTimePickerField } from "../../field/date-time-picker-field/date-time-picker-field"
import { FormProps } from "../form"
import { Formik } from "formik"
import { ModelField } from "../../field/model-field/model-field"
import { Text } from "../../text/text"
import { View } from "native-base"
import { color } from "../../../theme"
import { observer } from "mobx-react-lite"
import { translate } from "../../../i18n"
import moment from "moment"

const TITLE: ViewStyle = {
  borderTopWidth: 1,
  borderColor: color.palette.background,
  paddingHorizontal: 16,
  paddingTop: 16,
  paddingBottom: 10,
}

const BORDER: ViewStyle = {
  backgroundColor: color.palette.background,
  height: 4,
}

export interface CycleCloseFormProps extends FormProps {
  /**
   * An optional style override useful for padding & margin.
   */
  initialValues?: {
    farm_id?: number
    pond_id?: number
    started_at?: string
    finished_at?: string
  }
}

/**
 * Describe your component here
 */
export const CycleCloseForm = observer(function CycleCloseForm(props: CycleCloseFormProps) {
  const {
    initialValues = {}, onSubmit, colorScheme = Appearance.getColorScheme(), innerRef,
    ...rest
  } = props

  // const input = {
  //   //
  // }

  // const nextInput = {
  //   //
  // }

  const validationSchema = yup.object({
    farm_id: yup.number().nullable().required().label(translate("cycleForm.farmId")),
    pond_id: yup.number().nullable().required().label(translate("cycleForm.pondId")),
    finished_at: yup.string()
      .test(function (value) {
        const valid = value > initialValues.started_at;
        if (valid) return true;
        return this.createError({
          path: 'finished_at',
          message: translate('yup.number.moreThan'),
          params: { more: moment(initialValues.started_at).format('DD MMMM YYYY') }
        })
      })
      .nullable().required().label(translate("cycleForm.finishedAt")),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {({ initialValues, values, setFieldValue, setFieldTouched }) => (
        <>
          <ModelField
            name="farm_id"
            txPrefix="cycleForm"
            colorScheme={colorScheme}
            formControlProps={{ isRequired: true }}
            modelPickerProps={{
              Model: Farm,
              isDisabled: !!initialValues.farm_id,
              onValueChange: async (value) => {
                await setFieldValue("pond_id", null)
                await setFieldValue("farm_id", value || null)
                await setFieldTouched("farm_id")
              },
            }}
          />
          <View style={TITLE}>
            <Text tx="cycleForm.cycleClose" preset="title3" colorScheme={colorScheme} />
          </View>
          <View style={BORDER} />
          <ModelField
            key={`${values.farm_id}-pond_id`}
            name="pond_id"
            txPrefix="cycleForm"
            colorScheme={colorScheme}
            formControlProps={{ isRequired: true }}
            modelPickerProps={{
              Model: Pond,
              fetchData: (model, search) => (
                model.fetch({
                  farm_id__eq: values.farm_id,
                  search,
                  sort: "name_alpha_numeric",
                })
              ),
              clearable: true,
              isDisabled: !values.farm_id || !!initialValues.pond_id,
            }}
          />
          <DateTimePickerField
            name="started_at"
            txPrefix="cycleForm"
            colorScheme={colorScheme}
            formControlProps={{ isRequired: true, isDisabled: true }}
          />
          <DateTimePickerField
            name="finished_at"
            txPrefix="cycleForm"
            colorScheme={colorScheme}
            formControlProps={{ isRequired: true }}
            dateTimePickerProps={{
              dateTimePickerProps: {
                minimumDate: moment(initialValues.started_at).add(1, 'day').toDate(),
                maximumDate: moment(initialValues.started_at).add(6, 'months').toDate()
              }
            }}
          />
        </>
      )}
    </Formik>
  )
})

CycleCloseForm.displayName = 'CycleCloseForm'
